var slot = 'slot_slot__1n50dn60';

export { slot };
//# sourceMappingURL=slot.vanilla.mjs.map
